import React from 'react';
import { IconChevronRight } from '@americanexpress/dls-icons';
import { NetworkHighlightBlock } from '../CulinaryCollective/interface';
import LFLink from '../common/LFLink';

interface NetworkHighlightsProps {
  highlights: NetworkHighlightBlock[];
}

const NetworkHighlights: React.FC<NetworkHighlightsProps> = ({
  highlights,
}) => {
  return (
    <div className="tw-mt-10 tw-grid tw-grid-cols-1 tw-gap-10 md_tw-grid-cols-3">
      {highlights?.map((highlightBlock) => (
        <div key={`network-highlight-block-${highlightBlock.title}`}>
          {highlightBlock.image && (
            <div className="tw-aspect-image tw-w-full tw-overflow-hidden tw-rounded-2xl">
              <img
                src={highlightBlock.image}
                alt={highlightBlock.title}
                className="tw-h-full tw-w-full tw-object-cover"
              />
            </div>
          )}
          <div className="tw-mt-4 tw-font-sans tw-text-base tw-text-gray-800">
            <span className="tw-font-bold">{highlightBlock.title} — </span>
            <span
              dangerouslySetInnerHTML={{ __html: highlightBlock.description }}
            />
          </div>
          {!!highlightBlock.linkText && (
            <div className="tw-mt-4">
              <LFLink
                to={
                  highlightBlock.link || 'centurion-network/culinary-collective'
                }
                className="tw-font-medium tw-text-link hover_tw-underline"
              >
                {highlightBlock.linkText}
                <IconChevronRight
                  size="xs"
                  isFilled={true}
                  className="tw-mb-px tw-ml-2 tw-mr-1 tw-text-blue-bright-shade-600-s8"
                />
              </LFLink>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default NetworkHighlights;
